export const adozioneTranslations = {
  it: {
    kicker: "Adozione a distanza",
    titleLines: ["Regala un futuro", "a un bambino."],
    sub: "Con 30 € al mese garantisci a un bambino del sud del Madagascar istruzione, pasti caldi e cure mediche. Basta 1 euro al giorno: il costo di un caffè.",
    ctaPrimary: "Adotta ora",
    ctaSecondary: "Scopri come funziona",
    backHome: "Torna alla home",
    howLabel: "Come funziona",
    howTitle: "Tre passi, un legame per sempre.",
    steps: [
      {
        n: "01",
        title: "Compila il modulo",
        text: "Nome, email e un minuto del tuo tempo: nient'altro. Ti ricontattiamo noi.",
      },
      {
        n: "02",
        title: "Attiva il sostegno",
        text: "30 € al mese o 360 € all'anno, con pagamento sicuro. Nessun vincolo: puoi interrompere quando vuoi.",
      },
      {
        n: "03",
        title: "Conosci il tuo bambino",
        text: "Riceverai la sua foto, notizie dalla scuola e i suoi disegni: un legame che cresce nel tempo.",
      },
    ],
    receiveLabel: "Cosa riceverai",
    receiveTitle: "Vicini, anche da lontano.",
    receive: [
      {
        key: "photo",
        title: "Foto e notizie",
        text: "La foto del tuo bambino e aggiornamenti sulla sua vita e sulla sua famiglia.",
      },
      {
        key: "letters",
        title: "Disegni e lettere",
        text: "Disegni e messaggi scritti apposta per te, per un legame ancora più profondo.",
      },
      {
        key: "school",
        title: "Risultati scolastici",
        text: "Notizie su pagelle, salute e progressi durante tutto l'anno.",
      },
      {
        key: "projects",
        title: "Aggiornamenti sui progetti",
        text: "Ti raccontiamo come cresce la sua comunità grazie al tuo aiuto.",
      },
    ],
    formLabel: "Modulo di impegno",
    formTitle: "Inizia oggi il tuo sostegno.",
    formSub: "Compila il modulo e attiva il versamento: ti presenteremo il bambino che accompagnerai.",
    name: "Nome",
    surname: "Cognome",
    email: "Email",
    phone: "Telefono",
    planLabel: "Scegli il versamento",
    planMonthly: "Mensile",
    planMonthlyPrice: "30 € al mese",
    planAnnual: "Annuale",
    planAnnualPrice: "360 € all'anno",
    submit: "Completa la tua adozione",
    sending: "Invio in corso…",
    success: "Richiesta inviata! Si apre il pagamento sicuro per attivare il sostegno.",
    error: "Qualcosa è andato storto. Riprova.",
    note: "Nessun vincolo: puoi interrompere il sostegno in qualsiasi momento scrivendoci a you4mada@gmail.com.",
    faqLabel: "Domande frequenti",
    faqTitle: "Tutto quello che c'è da sapere.",
    faq: [
      {
        q: "Cos'è l'adozione a distanza?",
        a: "Un sostegno economico continuativo a un bambino: non è un'adozione legale, ma un modo concreto per garantirgli istruzione, cibo quotidiano e cure mediche.",
      },
      {
        q: "Quanto costa?",
        a: "30 € al mese — solo 1 euro al giorno, il costo di un caffè. Se preferisci, puoi versare 360 € una volta all'anno.",
      },
      {
        q: "Posso interrompere quando voglio?",
        a: "Sì, in qualsiasi momento e senza spiegazioni: basta scriverci a you4mada@gmail.com.",
      },
      {
        q: "Sosterrò sempre lo stesso bambino?",
        a: "Sì, fino alla maggiore età o al termine del suo percorso di studi. Se la sua famiglia si trasferisce o lui interrompe gli studi, ti presenteremo un altro bambino che ha bisogno di te.",
      },
      {
        q: "Come viene usato il mio contributo?",
        a: "Interamente sul territorio: mensa scolastica, materiale didattico e visite mediche. I costi di gestione e di corrispondenza li copriamo noi volontari.",
      },
    ],
    testimonials: [
      {
        quote: "Desideravo da tempo aiutare un bambino: ora ricevo le sue lettere e so che sta studiando. Una gioia immensa.",
        author: "Marina T. · sorella adottiva",
      },
      {
        quote: "Trasparenti e concreti: vedi dove va ogni euro.",
        author: "Luca B. · genitore adottivo",
      },
      {
        quote: "I suoi disegni sono appesi in cucina. I miei figli lo considerano un fratello lontano.",
        author: "Francesca R. · mamma adottiva",
      },
      {
        quote: "Un euro al giorno che vale più di qualsiasi altra spesa che faccio. Lo rifarei mille volte.",
        author: "Giovanni M. · genitore adottivo",
      },
      {
        quote: "Quando è arrivata la prima pagella ho pianto: quel bambino ce la sta facendo, e un po' è anche merito nostro.",
        author: "Elena e Paolo S. · famiglia adottiva",
      },
    ],
  },
  en: {
    kicker: "Child sponsorship",
    titleLines: ["Give a child", "a future."],
    sub: "With €30 a month you give a child in southern Madagascar education, warm meals and medical care. That's just €1 a day: the price of a coffee.",
    ctaPrimary: "Sponsor now",
    ctaSecondary: "See how it works",
    backHome: "Back to home",
    howLabel: "How it works",
    howTitle: "Three steps, a bond forever.",
    steps: [
      {
        n: "01",
        title: "Fill in the form",
        text: "Name, email and one minute of your time: nothing else. We'll get back to you.",
      },
      {
        n: "02",
        title: "Activate your support",
        text: "€30 a month or €360 a year, with secure payment. No strings attached: cancel anytime.",
      },
      {
        n: "03",
        title: "Meet your child",
        text: "You'll receive their photo, school news and drawings: a bond that grows over time.",
      },
    ],
    receiveLabel: "What you'll receive",
    receiveTitle: "Close, even from afar.",
    receive: [
      {
        key: "photo",
        title: "Photos and news",
        text: "Your child's photo and updates about their life and family.",
      },
      {
        key: "letters",
        title: "Drawings and letters",
        text: "Drawings and messages written just for you, for an even deeper bond.",
      },
      {
        key: "school",
        title: "School progress",
        text: "News about grades, health and progress throughout the year.",
      },
      {
        key: "projects",
        title: "Project updates",
        text: "We'll show you how their community grows thanks to your help.",
      },
    ],
    formLabel: "Commitment form",
    formTitle: "Start your support today.",
    formSub: "Fill in the form and activate the payment: we'll introduce you to the child you'll walk with.",
    name: "First name",
    surname: "Last name",
    email: "Email",
    phone: "Phone",
    planLabel: "Choose your plan",
    planMonthly: "Monthly",
    planMonthlyPrice: "€30 per month",
    planAnnual: "Annual",
    planAnnualPrice: "€360 per year",
    submit: "Complete your sponsorship",
    sending: "Sending…",
    success: "Request sent! The secure payment is opening to activate your support.",
    error: "Something went wrong. Please try again.",
    note: "No strings attached: you can stop your support anytime by writing to you4mada@gmail.com.",
    faqLabel: "FAQ",
    faqTitle: "Everything you need to know.",
    faq: [
      {
        q: "What is child sponsorship?",
        a: "A continuous financial support to a child: it's not a legal adoption, but a concrete way to guarantee them education, daily food and medical care.",
      },
      {
        q: "How much does it cost?",
        a: "€30 a month — just €1 a day, the price of a coffee. If you prefer, you can pay €360 once a year.",
      },
      {
        q: "Can I cancel anytime?",
        a: "Yes, anytime and with no explanation needed: just write to you4mada@gmail.com.",
      },
      {
        q: "Will I always support the same child?",
        a: "Yes, until they turn 18 or finish their studies. If their family moves or they leave school, we'll introduce you to another child who needs you.",
      },
      {
        q: "How is my contribution used?",
        a: "Entirely on the field: school canteen, learning materials and medical check-ups. Management and correspondence costs are covered by us volunteers.",
      },
    ],
    testimonials: [
      {
        quote: "I had wanted to help a child for a long time: now I receive their letters and know they're studying. Pure joy.",
        author: "Marina T. · sponsor sister",
      },
      {
        quote: "Transparent and concrete: you see where every euro goes.",
        author: "Luca B. · sponsor parent",
      },
      {
        quote: "His drawings hang in our kitchen. My children consider him a faraway brother.",
        author: "Francesca R. · sponsor mum",
      },
      {
        quote: "One euro a day worth more than anything else I spend. I would do it a thousand times over.",
        author: "Giovanni M. · sponsor parent",
      },
      {
        quote: "When the first report card arrived I cried: that child is making it, and part of it is thanks to us.",
        author: "Elena & Paolo S. · sponsor family",
      },
    ],
  },
};
